export interface FeaturesState {
  coverage: CoverageState;
}

// #region Coverage
type Rubric = 1 | 2 | 3 | 4;

interface RubricState {
  premise: Rubric;
  plot: Rubric;
  production_value: Rubric;
  characters: Rubric;
  setting: Rubric;
  structure: Rubric;
  casting_potential: Rubric;
  rubric_id?: string;
  coverage_id?: string;
}

export interface CoverageState {
  title: string;
  coverage_id?: string;
  document_id?: string;
  logline: string;
  submitted_by: string;
  submitted_to: string;
  author: string;
  length: number;
  estimated_duration: string;
  location: string;
  budget: number;
  reader: string;
  genre: string;
  similar_projects: string;
  coverage_date: string;
  created_at: string;
  rubric: RubricState;
  updated_at?: string;
  script_recommendation?: "pass" | "consider" | "recommend" | null;
  writer_recommendation?: "pass" | "consider" | "recommend" | null;
  analysis: {
    summary: string;
    comments: string;
    strengths?: string;
    weaknesses?: string;
    themes?: string;
    notes?: string;
    coverage_analysis_id?: string;
    coverage_id?: string;
  };
}

export const DefaultCoverageState: CoverageState = {
  title: "",
  coverage_id: undefined,
  document_id: undefined,
  logline: "",
  submitted_by: "",
  submitted_to: "",
  author: "",
  length: 0,
  estimated_duration: "",
  location: "",
  budget: 0,
  reader: "",
  genre: "",
  similar_projects: "",
  coverage_date: "",
  created_at: "",
  rubric: {
    premise: 1,
    plot: 1,
    production_value: 1,
    characters: 1,
    setting: 1,
    structure: 1,
    casting_potential: 1,
    rubric_id: undefined,
    coverage_id: undefined,
  },
  updated_at: undefined,
  analysis: {
    summary: "",
    comments: "",
    coverage_analysis_id: undefined,
    coverage_id: undefined,
  },
};
// #endregion Coverage
